<template>
	<div class="d-flex">
		<navigator />
		<div class="create-survey">
			<div class="title-header">
				<h1>{{ isNew ? "Create" : "Edit" }} {{ isSurvey ? "Survey" : isTemplate ? "Template" : "" }}</h1>
			</div>
			<ProgressBar @nodeClick="changeStep" :progressSteps="steps[modeIndex]" :step="step" />
			<div class="survey-container">
				<div>
					<transition name="fade">
						<Loading v-if="isLoading"></Loading>
					</transition>
				</div>
				<div v-if="page === -1">
					<SelectSurveyStart @create-new="clickNew" @use-template="clickTemplate" />
				</div>
				<div v-if="page === 0" class="h-100">
					<SearchSurveys mode="template-select" @select-item="clickSelect" />
				</div>
				<div v-if="page === 1">
					<SurveyMetaData :template="template" :mode="mode" />
				</div>
				<div v-if="page === 2">
					<EditQuestions :questions="template.questions" :showFlags="!canPublish" @remove-question="removeQuestion" @review-request="reviewRequestSurvey" />
				</div>
				<div v-if="page === 3">
					<div class="review-box">
						<PreviewSurvey :questions="template.questions" />
					</div>
				</div>
			</div>
			<div v-if="page !== -1" class="survey-nav">
				<div class="survey-nav-button">
					<b-button v-if="page >= 2 || modeIndex === 0 && page >= 0" @click="clickPrevious" class="nav-button">Previous</b-button>
				</div>
				<div class="survey-nav-button">
					<b-button v-show="page >= 3" class="nav-button-alt" v-b-modal.check-publish-confirm :disabled="!canPublish"  :class="{ 'disabled-button': !canPublish }">
						Publish
					</b-button>

					<b-modal id="check-publish-confirm" centered title="Confirm">
						<p class="confirm-modal-text">Are you sure you would like to publish this survey?</p>
						<template #modal-footer>
							<div class="float-right">
								<b-button class="close-button" @click="closeCheckModal">
									Close
								</b-button>
								<b-button class="publish-button" @click.once="publishSurvey">
									Publish
								</b-button>
							</div>
						</template>
					</b-modal>


					<!-- <b-button v-if="page >= 1" class="nav-button" v-b-modal.preview-survey>
						Preview
					</b-button> -->
					<!-- Preview survey modal - opens when the above button is clicked -->
					<b-modal id="preview-survey" title="Preview Survey" size="xl" hide-footer>
						<PreviewSurvey :questions="template.questions" />
					</b-modal>

					<!--  Hook: disable and visually grey out this button when backend validation failse -->
					<b-button v-if="page >= 3" class="nav-button" v-b-modal.publish-confirm>
						Save as Draft
					</b-button>
					<!-- Publish confirm modal - opens when the above button is clicked -->
					<b-modal id="publish-confirm" centered title="Confirm">
						<p class="confirm-modal-text">Are you sure you would like to {{ messages[modeIndex] }}</p>
						<template #modal-footer>
							<div class="float-right">
								<b-button class="close-button" @click="closeConfirmModal">
									Close
								</b-button>
								<b-button class="publish-button" @click="createSurvey(0)">
									{{ steps[modeIndex][step] }}
								</b-button>
							</div>
						</template>
					</b-modal>

					<!-- Hook: show this modal when backend moderation finds blacklist words -->
					<b-modal id="publish-unavailable" centered title="Publish unavailable">
						  <p class="confirm-modal-text">
							Your survey has been flagged by our automatic moderation.
							 It may not be shown to all users. Please edit the question(s) or request manual review.
							 </p>
						  <template #modal-footer>
							<div class="float-right">
								<b-button class="close-button" @click="closeUnavailableModal">
									Close
								</b-button>
							</div>
						</template>
					</b-modal>
					
					<b-button v-if="page <= 2" @click="clickNext" class="nav-button">
						Next
					</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import navigator from "../layout/NavBarNew.vue";
import SelectSurveyStart from "./SelectSurveyStart.vue";
import EditQuestions from "./EditQuestions.vue";
import PreviewSurvey from "./PreviewSurvey.vue";
import Loading from "../loading/index.vue"
import SurveyMetaData from "./SurveyMetaData.vue";
import SearchSurveys from "../survey-dashboard/SearchSurveys.vue";
import ProgressBar from "./ProgressBar.vue";
import Template from "../../Firestore/Template.js";
import GamesObject from "../../Firestore/GamesObject.js";
import Moderation from "../../Firestore/Moderation.js";
import Notifications from "../../Firestore/Notifications.js";
import Chat from "../../Firestore/Chat.js";
import Response from "../../Firestore/Response.js";
import API_URL from '../../api/config.js'

export default {
	name: "EditSurvey",
	components: {
		SelectSurveyStart,
		EditQuestions,
		PreviewSurvey,
		navigator,
		Loading,
		SurveyMetaData,
		SearchSurveys,
		ProgressBar,
	},
	props: {
    mode: { // One of "survey", or "template"
      type: String,
      default: "",
    },
    itemId: {
      type: String,
      default: "new",
    },
	},
	data() {
		return {
			userId: window.localStorage.getItem("userId"),
      		userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,  // 0: Tester, 1: Developer, 2: Admin
			gameId: window.localStorage.getItem("gameId"),
			isLoading: false,
			step: 1,
			isTemplateSelect: false,
			template: {
				name: "",
				tags: [],
        		description: "",
				questions: [],
			},
			steps: [ // Index into using modeIndex
				["Select Template", "Survey Details", "Add Questions", "Review", "Save"],
				["Survey Details", "Edit Questions", "Review", "Save"],
				["Template Details", "Add Questions", "Review", "Publish"],
				["Template Details", "Edit Questions", "Review", "Save"],
			],
			messages: [ // Index into using modeIndex
				"add this survey to the project?",
				"save this survey?",
				"publish this template?",
				"save this template?",
			],
			project: {},
		}
	},
	computed: {
		isNew() {
			return this.itemId.toLowerCase() === "new";
		},
		isSurvey() {
			return this.mode.toLowerCase() === "survey";
		},
		isTemplate() {
			return this.mode.toLowerCase() === "template";
		},
		modeIndex() {
			if (this.isSurvey) {
				if (this.isNew) {
					return 0;
				} else {
					return 1;
				}
			} else if (this.isTemplate) {
				if (this.isNew) {
					return 2;
				} else {
					return 3;
				}
			} else {
				return -1;
			}
		},
		page() {
			if (this.modeIndex === 0) {
				return this.step - (this.step === 1 && !this.isTemplateSelect) - 1;
			} else {
				return this.step;
			}
		},
		// Check if survey/template can be published (i.e. has no flagged questions)
		canPublish() {
			JSON.stringify(this.template.questions);
    		return !this.template.questions.some(q => q.flagged)
  		},		
	},
	watch: {
		itemId() {
			this.getSurvey();
		},
		modeIndex() {
			if (this.modeIndex === -1) {
				this.$router.push({
					path: "/",
				});
			}
		},
	},
	mounted() {
		if (!this.userId || this.userType === -1) {
			this.$router.push({
				name: "login",
			});
		} else if ((this.isSurvey && this.userType !== 1 && this.userType !== 2) ||
							(this.isTemplate && this.userType !== 2) ||
								(this.modeIndex === -1)) {
			this.$router.push({
				path: "/",
			});
		}
		this.getSurvey();
		this.getProject();
		this.showLoadingScreen();
	},
	methods: {
		getSurvey() {
			if (!this.isNew) {
				if (this.isSurvey) {
					Template.getSurvey(this.itemId).then(res => {
						if (res.success) {
							this.template = res.data;
						} else {
							this.$router.push({
								path: "/",
							});
						}
					});
				} else if (this.isTemplate) {
					Template.getTemplate(this.itemId).then(res => {
						if (res.success) {
							this.template = res.data;
						} else {
							this.$router.push({
								path: "/",
							});
						}
					});
				}
			}
		},
		getProject() {
			if (this.isSurvey && this.gameId) {
				GamesObject.getProject(this.gameId).then(res => {
					this.project = res.data;
				});
			}
		},
		showLoadingScreen() {
			this.isLoading = true;
			setTimeout(() => this.isLoading = false, 200);
		},
		clickNew() {
			this.resetTemplate();
			this.step = 2;
		},
		clickTemplate() {
			this.resetTemplate();
			this.step = 1;
			this.isTemplateSelect = true;
		},
		resetTemplate() {
			// Reset to a blank template
			this.template = {
				"name": "",
				"description": "",
				"tags": [],
				"questions": [],
			};
		},
		clickSelect(template) {
			this.template = template;
			this.step = 2;
		},
		clickPrevious() {
			if (this.step === 1 && this.isTemplateSelect) {
				this.isTemplateSelect = false;
			} else {
				this.step -= 1;
			}
			
			const el = document.getElementsByClassName("survey-container")[0];
			el.scrollTop = 0;
		},
		clickNext() {
			this.step += 1;

			const el = document.getElementsByClassName("survey-container")[0];
			el.scrollTop = 0;
			console.log(this.step);
		},
		closeConfirmModal() {
			this.$bvModal.hide("publish-confirm");
		},
		removeQuestion(index) {
			this.template.questions.splice(index, 1);
		},
		reviewRequestSurvey(reviewText) {
			Template.setSurveyStatusAndReviewRequest(this.itemId, 3, reviewText)
				.then(async () => {
					let submitterName = null;
					try {
						const res = await Chat.getUserInfo(window.localStorage.getItem("userId"));
						submitterName = res.data.userName || res.data.nickName || null;
					} catch (e) {
						submitterName = null;
					}

					Notifications.createRoleNotification(
						2,
						"survey-approval",
						"New survey to approve!",
						reviewText ? `Reason given: ${reviewText}` : "",
						{
							surveyId: this.itemId,
							surveyName: this.template.name || "Untitled survey",
							projectId: window.localStorage.getItem("gameId") || null,
							submitterName,
						}
					);
				})
				.catch(e => console.log(e));

			if (this.isTemplate) {
				this.$router.push({
					name: "templates",
				});
			} else if (this.isSurvey) {
				if (this.gameId) {
					window.localStorage.setItem("gameDetailIndex", 1);
					this.$router.push({
						name: "gamedetail",
					});
				} else {
					this.$router.push({
						name: "surveys",
					});
				}
			} else {				
				this.$router.push({
					path: "/",
				});
			}
		},
		changeStep(step, length) {
			if (step === length) {
				this.$bvModal.show("publish-confirm");
			} else {
				this.step = step;
			}
		},
		/**
		 * Create or update survey/template based on modeIndex
		 * Status codes:
		 * 0 = Draft
		 * 1 = Published
		 * 2 = Archived
		 * 3 = Pending Approval
		 * 4 = Approved
		 * 5 = Flagged
		 * @param status status is only used when creating a survey to set its status. Defaults to 0 (draft).
		 */
		async createSurvey(status = 0) {
			let surveyId = null;

			// Create new Survey (modeIndex === 0)
			if (this.modeIndex === 0 && (this.userType === 1 || this.userType === 2)) {
				const res = await Template.createSurvey(
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
					window.localStorage.getItem("gameId"),
					window.localStorage.getItem("userId"),
					status,
				);
				surveyId = res.data;
			// Update existing Survey (modeIndex === 1)
			} else if (this.modeIndex === 1 && (this.userType === 1 || this.userType === 2)) {
				const res = await Template.updateSurvey(
					this.itemId,
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
				);
				
				// Clear feedback and review request 
				if (status === 1) {
					Template.setSurveyStatusRemoveFeedback(this.itemId, 1); 
					Template.setSurveyStatusRemoveReviewRequest(this.itemId, 1); 
				}
				
				if (res && res.success) {
					surveyId = this.itemId;
					
					// Assign survey to all testers
					Response.assignSurveyToAll(surveyId, this.gameId)
						.catch(e => console.log(e));
				} else {
					console.error("Failed to update survey:", res && res.error);
				}
			// Template creation (modeIndex === 2)
			} else if (this.modeIndex === 2 && this.userType === 2) {
				await Template.createTemplate(
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
				);
			// Template update (modeIndex === 3)
			} else if (this.modeIndex === 3 && this.userType === 2) {
				await Template.updateTemplate(
					this.itemId,
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
				);
				
				// Clear feedback and review request 
				if (status === 1) {
					Template.setSurveyStatusRemoveFeedback(this.itemId, 1); 
					Template.setSurveyStatusRemoveReviewRequest(this.itemId, 1); 
				}
			}

			// Handle navigation after create/update
			if (this.isTemplate) {
				this.$router.push({ name: "templates" });
			} else if (this.isSurvey) {
				if (this.gameId) {
					window.localStorage.setItem("gameDetailIndex", 1);
					this.$router.push({ name: "gamedetail" });
				} else {
					this.$router.push({ name: "surveys" });
				}
			} else {				
				this.$router.push({ path: "/" });
			}

			// Return surveyId for use in publishSurvey
			return surveyId;
		},

		/**
		 * Create or update survey and continue to edit if flagged
		 */
		async createAndEditSurvey() {
			if (this.modeIndex === 0 && (this.userType === 1 || this.userType === 2)) {
				const response = await Template.createSurvey(
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
					window.localStorage.getItem("gameId"),
					window.localStorage.getItem("userId"),
					5, // Status 5 = flagged 
				);
				if (response.success) {
					this.itemId = response.data; // contains the survey ID
					this.getSurvey();
				} else {
					console.error("Failed to create survey:", response.error);
				}
			} else if (this.modeIndex === 1 && (this.userType === 1 || this.userType === 2)) {
				const response = await Template.updateSurvey(
					this.itemId,
					this.template.name,
					JSON.parse(JSON.stringify(this.template.tags)),
					JSON.parse(JSON.stringify(this.template.questions)),
					this.template.description,
				);
				await Template.setSurveyStatus(this.itemId, 5); // Status 5 = flagged
				if (response.success) {
					this.getSurvey();
				} else {
					console.error("Failed to update survey:", response.error);
				}
			}
		},

		/**
		 * Create/update and publish survey after moderation check.
		 * Create/update and continue to edit if flagged
		 */
		async publishSurvey() {
			try {

				console.log("🔶 publishSurvey() TRIGGERED");
				console.log("template:", this.template);
				console.log("modeIndex:", this.modeIndex);
				console.log("userType:", this.userType);

				// TASK 2: Run AI moderation first (if agent is configured)
				let surveyId = this.itemId || 'draft';
				const clientId = 'default-client'; // TODO: Get from user's client

				await Moderation.moderateSurveyWithAI(this.template, surveyId, clientId);
				console.log("Survey passed AI moderation");

				const result = await Moderation.moderateSurvey(this.template);
				console.log("🟩 Survey passed moderation");

				this.closeCheckModal();


				// Get gameId and surveyId
				surveyId = this.isNew ? null : this.itemId;
				let gameId = this.gameId || this.template.gameID || window.localStorage.getItem("gameId");

				console.log("🟦 Before publish: surveyId =", surveyId, "gameId =", gameId);

				// Published status
				if (this.modeIndex === 0 && (this.userType === 1 || this.userType === 2)) {
					console.log("🟧 Creating NEW survey with status=1");
					const createdSurveyId = await this.createSurvey(1);  

					console.log("🟩 createSurvey returned:", createdSurveyId);
					if (createdSurveyId) {
						surveyId = createdSurveyId;
					}
				} else if (this.modeIndex === 1 && (this.userType === 1 || this.userType === 2)) {
					console.log("🟨 Updating existing survey → status=1");
					await this.createSurvey(1);          
					await Template.setSurveyStatus(this.itemId, 1);
					surveyId = this.itemId;
				} else {
					console.log("ℹ Not a tester-survey publish scenario, skip tester notification.");
					return;
				}

				console.log("🟦 FINAL surveyId used for notification =", surveyId);
				console.log("🟦 FINAL gameId =", gameId);

				if (!surveyId || !gameId) {
					console.warn("⚠ Missing surveyId or gameId, skip notification");
					return;
				}

				// Send notification to all testers
				console.log("📨 Calling sendSurveyCreatedNotification()...");
				await Template.sendSurveyCreatedNotification(gameId, surveyId);

				//send email to all testers
				const response = await fetch(`${API_URL}/email/testers/${gameId}/survey-notif`, {
					method: 'POST'
				})

				const data = await response.json();
				if (!data.success) {
					throw new Error(data.error || "Failed sending email")
				}

				console.log("Testers recieved email");
				console.log("🟢 Notification SENT successfully!");

			} catch (e) {
				console.warn("Survey flagged by moderation:", e);
				this.closeCheckModal();
				await this.createAndEditSurvey();
				this.$bvModal.show("publish-unavailable");
			}
		},

		closeCheckModal() {
			this.$bvModal.hide("check-publish-confirm");
		},
		closeUnavailableModal() {
			this.$bvModal.hide("publish-unavailable");
			this.step = 2;
		},
	},
};
</script>

<style scoped>
.create-survey {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  margin: 0px 0px 0px auto;
  background-color: #EEEEEE;
}

.title-header {
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 75px;
	width: 100%;
	box-shadow: 0 4px 10px -6px grey;
}

.title-header h1 {
  color: #FF7222;
  font-weight: bold;
}

h4 {
  color: #FF7222;
  font-weight: bold;
  margin: 1rem 0px;
}

.survey-container {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}

.survey-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 0.5rem;
  box-shadow: 0px -4px 10px -6px grey;
  width: 100%;
}

.survey-nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  width: 8rem;
  height: 2.5rem;
}

button.nav-button:hover {
  background: #ff8e4d !important;
}

.nav-button:active,
.nav-button:focus {
  background: #FF7222 !important;
}

.nav-button-alt {
  background: #DB3360 !important;
  margin: 5px;
  border: 0 !important;
  width: 8rem;
  height: 2.5rem;
}

button.nav-button-alt:hover {
  background: #DB3360 !important;
}

.nav-button-alt:active,
.nav-button-alt:focus {
  background: #DB3360 !important;
}


.publish-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.publish-button:hover {
  background: #ff8e4d !important;
}

.publish-button:focus,
.publish-button:active {
  background: #FF7222 !important;
}

.publish-button[disabled],
.publish-button.disabled-button {
  background: #6c757d !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.close-button {
  background-color: #fc7727 !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.close-button:hover {
  background-color: #ff8e4d !important;
}

.close-button:focus,
.close-button:active {
  background: #6c757d !important;
}

.placeholder-container {
  margin: 1rem;
  background-color: white;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

button {
  border: 0 !important;
  background-color: transparent !important;
}

.confirm-modal-text {
  color: black !important;
  margin: 0.5rem;
}

.question-container {
    margin: 1rem 0.5rem 0 0.5rem;
	padding: 1.5rem 3rem;
	background-color: white;
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
    width: 80%;
}

 .question-text-box {
    border-color: lightgray;
	border-top-style: none;
	border-left-style: none;
	border-right-style: none;
	border-bottom-style: solid;
    border-width: thin;
    padding: 0.5rem;
    width: 60%;
    font-size: large;
}

.question-title-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 80%;
}

.question-title {
  color: #FF7222;
  width: 100%;
}

.question-number {
    color: #FF7222;
    margin: 0;
    padding-right: 1rem;
    font-weight: bold !important;
}

.question-head-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-bottom: 1rem;
}

.question-type-text {
	color: lightgray !important;
	font-style: italic;
}

.option-container {
	display: flex;
	width: 100%;
	margin: 0.5rem !important;
	align-items: center;
}

.option-text-box {
    border-color: lightgray;
	border-top-style: none;
	border-left-style: none;
	border-right-style: none;
	border-bottom-style: solid;
    border-width: thin;
    padding: 0.5rem !important;
    min-width: 15%;
	max-width: 85%;
	margin-left: 1rem;
}

.add-option-div {
	width: 100%;
	margin: 0.5rem !important;
	justify-content: center;
}

.add-option {
	background: transparent !important;
	border: 0 !important;
	color: gray !important;
}

.add-option:hover {
	background: lightgray !important;
	color: white !important;
}

.add-option:focus, .add-option:active {
    color: gray !important;
}

>>> .close {
  padding: 0px;
  margin-left: auto;
  margin-right: 2px;
  border: none;
  background: none;
  font-size: 24px;
}

.review-box {
  background-color: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  width: 90%;
  max-width: 900px;
}
</style>


// WEBPACK FOOTER //
// src/components/survey-create/EditSurvey.vue